import { forwardRef, useImperativeHandle, useState } from 'react';
import { Modal, Row, Col, Spin } from "antd";
import { useRequest } from "ahooks";
import { CardServer } from "../../../server";

const server = CardServer.Card;

export const ViewModal = forwardRef((props: any, ref: any) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [cardDetail, setCardDetail] = useState<any>({});

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any) => {
        if (typeof val !== 'boolean') {
            run({ CardId: val.CardId })
        }
        setVisiable(!!val);
    }

    const { run } = useRequest(server.detail, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            setCardDetail(res);
        }
    });

    return (
        <div>
            <Modal
                title={'查看卡片敏感信息'}
                width={500}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                onCancel={() => changeVisible(false)}
                okButtonProps={{ loading }}
                onOk={async () => {
                    changeVisible(false)
                }}
            >
                <Spin spinning={loading}>
                    <Row gutter={16} className='mt20'>
                        <Col span={8} className='txtr'>卡号：</Col>
                        <Col span={8}>{cardDetail?.UdpayCardNumber}</Col>
                    </Row>
                    <Row gutter={16} className='mt20'>
                        <Col span={8} className='txtr'>CVV：</Col>
                        <Col span={8}>{cardDetail?.UdpayCvv}</Col>
                    </Row>
                    <Row gutter={16} className='mt20'>
                        <Col span={8} className='txtr'>过期时间：</Col>
                        <Col span={8}>{cardDetail?.UdpayExpireDate}</Col>
                    </Row>
                </Spin>
            </Modal>
        </div>
    );
})
